import { Col, Row } from "react-bootstrap";

export const SignatureGallery = ({ signatures }) => {
    const signatureIds = signatures ? Object.keys(signatures) : [];

    if (!signatureIds.length) {
        return (
            <p className="text-muted text-center py-3 mb-0">
                No signatures saved yet.
            </p>
        );
    }

    return (
        <Row className="g-4">
            {signatureIds.map((id) => (
                <Col key={id} xs={6} md={3}>
                    <img
                        src={signatures[id]}
                        alt={`Signature ${id}`}
                        className="rounded border border-secondary img-fluid"
                        style={{
                            width: "100%",
                            height: "100px",
                            objectFit: "contain",
                        }}
                    />
                </Col>
            ))}
        </Row>
    );
};